// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  // baseUrl: 'https://api.wallet2cash.com'
  // baseUrl: 'https://localhost:5001',
  apiUrl: 'https://api.wallet2cash.com',
  baseUrl: 'https://api.bluecore.wallet2cash.com',
  // baseUrl: 'https://api.bluecore.wallet2cash.com',
  // baseUrl: 'https://1fa9-103-174-195-191.ngrok-free.app'
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
